/**Return display name for a case plan coverage */
export function formatCasePlanCoverageName(coverage: { name?: string, casePlanCoverageDesc?: string}): string {
    return (coverage.name || '') + ( coverage.casePlanCoverageDesc ? ' | ' + coverage.casePlanCoverageDesc : '');
}